import { validateMaxLength,validateMaxLengthRequired } from "presentation/common";
import * as Yup from "yup";

export const DispatchSchema = data=> Yup.object().shape({
    place: Yup.mixed().required('El lugar es requerido.'),
    region: Yup.mixed().required('La región es requerida.'),
    comuna: Yup.mixed().required('La comuna es requerida.'),
    street: validateMaxLengthRequired(100,'La calle es requerida.'),
    number: validateMaxLengthRequired(10,'El número es requerido.'),
    complement: validateMaxLength(100)
  
}) 